import { isDevEnvironment } from '@/modules/UIDesign/Dev/services/environment';

export const SIGNATURE_PREVIEW_KEY = 'signature-auth-preview';
export const getSignaturePreviewContext = (context) => (isDevEnvironment && context?.marker === SIGNATURE_PREVIEW_KEY ? context : null);

export default {
  inject: { signaturePreviewContext: { from: SIGNATURE_PREVIEW_KEY, default: null } },
  props: { previewContext: { type: Object, default: null } },
  provide() { return { [SIGNATURE_PREVIEW_KEY]: this.signaturePreview }; },
  computed: {
    signaturePreview() { return getSignaturePreviewContext(this.previewContext || this.signaturePreviewContext); },
    signatureServices() { return this.signaturePreview || this.$models.auth; },
  },
};
